import React from "react";
import { Field, Input, Select } from "./ui";

// Provincia select + localidad with suggestions from the admin-managed list.
export const ProvLoc = ({ meta, provincia, localidad, onChange, testid = "provloc", locLabel = "Localidad *" }) => {
  const sugeridas = meta.localidades.filter((l) => l.provincia === provincia);
  const listId = `${testid}-list`;
  return (
    <>
      <Field label="Provincia *">
        <Select
          required
          value={provincia}
          placeholder="Elegí la provincia…"
          options={meta.provincias}
          onChange={(e) => onChange({ provincia: e.target.value, localidad: "" })}
          data-testid={`${testid}-provincia`}
        />
      </Field>
      <Field label={locLabel}>
        <Input
          required
          list={listId}
          value={localidad}
          placeholder={provincia ? "Escribí o elegí la localidad" : "Primero elegí provincia"}
          onChange={(e) => onChange({ provincia, localidad: e.target.value })}
          data-testid={`${testid}-localidad`}
        />
        <datalist id={listId}>
          {sugeridas.map((l) => <option key={l.id} value={l.localidad} />)}
        </datalist>
      </Field>
    </>
  );
};

export default ProvLoc;
